export default function Footer() {
  return (
    <footer className="hairline-t">
      <div className="container-editorial py-14 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <img
            src="/media/cara-logo.png"
            alt="Cara Capital"
            className="h-9 md:h-10 w-auto"
            draggable="false"
          />
          <div className="italic-serif mt-4" style={{ fontSize: 17, color: "var(--stone)" }}>
            The Capital Behind Care Convergence
          </div>
        </div>
        <div className="md:col-span-4">
          <div className="overline">In Partnership With</div>
          <div className="mt-3 font-serif" style={{ fontSize: 22, letterSpacing: "-0.01em" }}>
            Marram Ventures
          </div>
        </div>
        <div className="md:col-span-3 md:text-right">
          <div className="overline">Legal</div>
          <div className="mt-3 text-[13px]" style={{ color: "var(--stone)" }}>
            © 2026 Cara Capital. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
